import { useState, useRef, useEffect, useMemo } from 'react';
import _ from 'lodash';
import checkScrollPosition from './checkScrollPosition';

const useScrollPosition = (animationTiming: number) => {
  const [isCurrentPosition, setIsCurrentPosition] = useState(false);
  const ref = useRef<HTMLElement | null>(null);

  const handleScroll = useMemo(
    () =>
      _.debounce(() => {
        if (!ref.current) return;

        checkScrollPosition(
          ref.current,
          animationTiming,
          () => {
            setIsCurrentPosition((prev) => (prev ? prev : true));
          },
          () => {
            setIsCurrentPosition((prev) => (prev ? false : prev));
          }
        );
      }, 25),
    [animationTiming]
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel();
    };
  }, [handleScroll]);

  return {
    isCurrentPosition,
    ref,
  };
};

export default useScrollPosition;